import { boxShadows } from 'hfs-common-ui';
import styled from 'styled-components';
import { zFloatingPanels } from '~/styled';
type Props = {
  $isSubMenuOpen?: boolean;
  $isUserMenu?: boolean;
};

export const DropdownMenuContent = styled.div`
  position: absolute;
  transition: all 200ms ease;
  right: 0;
  top: 42px;
  z-index: ${() => zFloatingPanels};
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  border-radius: 12px;
  line-height: 14px;
`;
export const NavMenuWrapper = styled.div``;

export const DropdownLink = styled.div<Props>`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${DropdownMenuContent} {
    visibility: ${({ $isSubMenuOpen }) => ($isSubMenuOpen ? 'visible' : 'hidden')};
    opacity: ${({ $isSubMenuOpen }) => ($isSubMenuOpen ? '1' : '0')};
    background-color: ${({ theme }) => theme.colors.surface};
    box-shadow: ${({ $isUserMenu }) => ($isUserMenu ? boxShadows.light : 'none')};
    ${NavMenuWrapper} {
      margin-top: 0;
      div {
        ${({ $isUserMenu }) => ($isUserMenu ? 'box-shadow:none' : '')};
      }
    }
  }
`;

export const UserHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  width: 208px;
  padding: 16px;
  height: 35px;
  position: absolute;
  border-top-left-radius: 12px;
  cursor: default;
  border-top-right-radius: 12px;
  background-color: ${({ theme }) => theme.colors.surface};
`;
